import { Button, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import { isAdmin } from "app/common/LocalFunction";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import FilterListIcon from "@material-ui/icons/FilterList";

const SearchAppointment = ({}) => {
  const isAdmins = isAdmin() 
  const theme = useTheme();
  let [isOpenFillter, setOpenFillter] = useState(true);
  return (
    <>
        <>
          <Grid container spacing={1} alignItems="center" style={{ display: "flex" }}>
              <Grid item xs={12} md={4}>
                <div
                  className=" flex justify-between gap-2"
                  style={{ fontSize: "16px" }}
                >
                  <span
                    className="cards-header flex items-center pointer"
                    style={{ fontWeight: "bold", padding: "10px" }}
                  >
                    Lịch hẹn
                    <FilterListIcon
                      style={{ marginRight: 8, cursor: "pointer" }}
                      onClick={() => setOpenFillter(!isOpenFillter)}
                    />
                  </span>
                </div>
              </Grid>
              {isOpenFillter && (
                <Grid item xs={12} md={8} >
                  <Grid container spacing={1} justifyContent="flex-end" style={{ padding:"10px"}}>
                    {/* Từ ngày - đến ngày */}
                    <Grid item xs={12} sm={6} md={4}>
                      <GlobitsMultiDatePicker
                        label="Từ ngày - đến ngày"
                        name="fromDate"
                        range
                        rangeHover
                        fromField="fromDate"
                        toField="toDate"
                        // format={"DD/MM/YYYY"}
                      />
                    </Grid>

                    {/* Cơ sở */}
                    <Grid item xs={12} sm={6} md={4}>
                      <GlobitsPagingAutocomplete
                        name={"departmentId"}
                        label={"Cơ sở"}
                        api={pagingDepartment}
                        disabled={!isAdmins}
                      />
                    </Grid>

                    {/* Nút tìm kiếm */}
                    <Grid item xs={12} sm={6} md={"auto"} className="flex justify-end" style={{alignItems:"end"}}>
                      <Button className="btn-primary" type="submit">
                        <Search /> Tìm kiếm
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              )}
          </Grid>
        </>
    </>
  );
};

export default memo(observer(SearchAppointment));